// Main js to state index
import utils from "./utils";
import map from "./map";
import table from "./table";
import graph from "./graph";

const stateIndex = {
    // wp_add_inline_script current queryied object
    stateIndexObject:
        typeof stateIndexObject == "undefined" ? null : stateIndexObject,

    // main init function for state-index and single state pages
    init: function () {
        if (!this.stateIndexObject) {
            return false;
        }

        if (this.stateIndexObject.post_type == "state") {
            // on single state, initialize compare listeners and ready to draw graphs
            graph.init();

            document.querySelectorAll(".pdf-download").forEach((pdfBtn) => {
                pdfBtn.addEventListener("click", (e) => {
                    e.preventDefault();
                    pdfBtn.classList.add("loading");
                    utils.statePdf(window.location.href + "pdf", function () {
                        pdfBtn.classList.remove("loading");
                    });
                });
            });
        } else {
            // index tool page draw map and table
            map.init();
            table.init();
        }
    },
};

const stateIndexer = stateIndex.init;
const stateIndexTool = stateIndexer.bind(stateIndex);

document.addEventListener("DOMContentLoaded", function () {
    stateIndexTool();
});
